// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".DashboardBox {\n  padding-left: 8vw;\n  padding-right: 8vw;\n}\n#dataTableTicket > div.v-data-table.theme--light > div.v-data-table__wrapper > table > tbody > tr:nth-child(n) > td:nth-child(n) > span {\n  min-width: 100px !important;\n  max-width: 100px !important;\n  justify-content: center !important;\n}", ""]);
// Exports
module.exports = exports;
